import dynamic from 'next/dynamic';
import React, { useState } from 'react';
import { match } from 'ts-pattern';

import TabHeader from '@/components/TabHeader';
import { PERIOD_ARTWORK_RANK } from '@/types/asset';

import { CATEGORY_TABS, CategoryKey, TIME_TABS } from '../constants';
import useArtworkRank from './ useArtworkRank';

const DynamicCollection = dynamic(() => import('./Collection'));
const DynamicArtwork = dynamic(() => import('./Artwork'));

const Rank: React.FC = () => {
  const [category, setCategory] = useState<CategoryKey>(CategoryKey.artwork);
  const { list, setPeriod, period } = useArtworkRank();

  const renderContentWithType = () => {
    return match(category)
      .with(CategoryKey.artwork, () => <DynamicArtwork list={list} period={period} />)
      .otherwise(() => <DynamicCollection list={list} period={period} />);
  };

  return (
    <div className="px-[40px] py-10 md:px-[20px]">
      <div className="flex items-center justify-between md:flex-wrap">
        <div className="flex items-center justify-center md:mb-4 md:w-full">
          <TabHeader
            list={CATEGORY_TABS}
            onChange={(key) => setCategory(key as CategoryKey)}
            classNames={{ item: 'w-[200px] md:w-[calc(100%)]', wrap: 'md:w-full' }}
          />
        </div>
        <div className="flex items-center justify-center md:w-full">
          <TabHeader
            list={TIME_TABS}
            defaultValue={PERIOD_ARTWORK_RANK.hour}
            onChange={(key) => setPeriod(key as PERIOD_ARTWORK_RANK)}
            classNames={{ item: 'w-[80px] md:w-[calc(100%)]', wrap: 'md:w-full' }}
          />
        </div>
      </div>
      {renderContentWithType()}
    </div>
  );
};

export default Rank;
